export default __webpack_public_path__ + "static/media/regua_nova.436d8bf1.png";